module.exports = __webpack_public_path__ + "static/media/phone.4961e9d5.svg";